// Package Imports
import moment from "moment"

// Project Imports
import isInteger from "utils/validations/isInteger"
import { isName } from "utils/validations/isName"
import { validateFieldsDetails } from "./validation"
import { fecthGenderOptionList } from "./utils"

// Dummy obejct to prefill all the family members field
const EmployeeMemberFieldStructureObject = {
    name: "",
    label: "",
    placeholder: "",
    extra: {
        isSelected: false
    },
    fields: [
        {
            name: 'id',
            value: '',
            type: 'hidden'
        },
        {
            name: "salutation",
            value: {},
            error: "Please fill the details",
            validators: [validateFieldsDetails],
            extra: {
                bottomSheetTitle: "Select Salutation",
                optionList: [
                ]
            }
        },
        {
            name: "first_name",
            type: "text",
            placeholder: "First Name",
            // validators: [isName]
             validators: [validateFieldsDetails]
        },
        {
            name: "middle_name",
            type: "text",
            placeholder: "Middle Name",
            // validators: [isName]
        },
        {
            name: "last_name",
            type: "text",
            placeholder: "Last Name",
            // validators: [isName]
            validators: [validateFieldsDetails]
        },
        {
            name: "gender",
            label: "Gender",
             validators: [validateFieldsDetails],
            value: {},
            extra: {
                bottomSheetTitle: 'Select Gender',
                optionList:[]
            }
        },
        {
            name: "dob",
            label: "Date of Birth",
            validators: [validateFieldsDetails],
            extra: {
                // calculate moment object
                minDate: moment().subtract(18, 'years'),
                maxDate: ""
            }
        },
        {
            name: "nationality",
            label: "Nationality",
            placeholder: "Nationality",
            validators: [validateFieldsDetails],
            value: {},
            extra: {
                bottomSheetTitle: "Select Nationality",
                optionList: [
                ]
            }
        },
        {
            name: "monthly_income_dropdown_option",
            type: "hidden",
            validators: [validateFieldsDetails],
            extra: {
                bottomSheetTitle: "Select Monthly Income",
            }
        },
        {
            name: "monthly_income_value",
            label: "Monthly Income",
            placeholder: "Enter Monthly Income",
            type: "text",
            validators: [isInteger, validateFieldsDetails],
            extra: {
                visible: true
            }
        },
        {
            name: "family_member_type",
            label: "",
            type: "text"
        },
        {
            name: "current_life_cover",
            label: "Current Life Cover",
            value: {},
            validators: [validateFieldsDetails],
            extra: {
                bottomSheetTitle: "Select Current Life Cover",
                optionList: []
            }
        },

        {
            name: "life_assured",
            label: "Life Assured",
            value: false,
            extra: {}
        },
        {
            name: "proposer",
            label: "Proposer",
            value: false,
            extra: {}
        },
        {
            name: "is_member_selected",
            label: "Member Selected",
            value: false,
            extra: {},
            disabled: false
        }
    ]
}


export default  EmployeeMemberFieldStructureObject